import { render, staticRenderFns } from "./NewProxyItem.vue?vue&type=template&id=c5a39f38&scoped=true"
import script from "./NewProxyItem.vue?vue&type=script&lang=js"
export * from "./NewProxyItem.vue?vue&type=script&lang=js"
import style0 from "./NewProxyItem.vue?vue&type=style&index=0&id=c5a39f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a39f38",
  null
  
)

export default component.exports